export default {
    title: 'Statistiky',
    filter: {
        toggle: 'Filtry',
        events: 'Události',
        eventsPlaceholder: 'Vše',
        devices: 'Zařízení',
        devicesPlaceholder: 'Vše',
        dateFrom: 'Od',
        dateTo: 'Do',
        interval: 'Rozlišení',
        intervalOptions: {
            auto: 'Automaticky',
            day: 'Den',
            hour: 'Hodina',
            minute: 'Minuta'
        },
        showEmpty: 'Zobrazit prázdné sady',
        submit: 'Zobrazit'
    },
    prompt: {
        beforeFirstFetch: 'Vyberte filtry a klikněte Zobrazit',
        noResults: 'Žádné záznamy pro zvolené filtry'
    },
    kpi: {
        validated: 'Zkontrolováno',
        total: 'Celkem vstupenek',
        percentLabel: 'z celkového počtu'
    },
    table: {
        title: 'Sady vstupenek',
        cols: {
            id: 'ID',
            event: 'Akce',
            name: 'Sada',
            toCheck: 'Ke kontrole',
            tickets: 'Vstupenek',
            people: 'Osob'
        },
        total: 'Celkem',
        sub: {
            title: 'Rozpis po zařízeních',
            empty: 'Žádný rozpis k dispozici',
            cols: {
                type: 'Typ',
                name: 'Jméno',
                count: 'Počet'
            }
        }
    },
    charts: {
        title: 'Aktivita zařízení',
        empty: 'Žádná data o aktivitě'
    },
    toast: {
        error: 'Chyba při načítání statistik'
    }
}
